import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { useSelector, useDispatch } from "react-redux";

export const PageError = () => {
  return (
    <Layout>
      <div class="Page-Thank jumbotron1">
        <div class="form-iconTB">
          <div class="form-cir">
            <i
              class="la la-exclamation-circle"
              style={{ color: "#c0392b" }}
            ></i>
          </div>
        </div>
        <p class="text-titleTB">Chủ cửa hàng chưa kích hoạt chức năng này!</p>
        <p class="text-MainTB">
          Hãy liên hệ với chủ cửa hàng để đăng ký nhận 15 data khách vay ngay!
        </p>
        <p class="lead hotline-text">
          Có bất kỳ vấn đề gì cần hỗ trợ hãy liên hệ với chúng tôi qua số điện
          thoại: <a href="callto://+0981528850">0981 528 850</a>
          <br />
          <span class="thank-u">Xin cám ơn!</span>
        </p>
      </div>
    </Layout>
  );
};
